import { Flex, Text } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import { FieldGroupBox, RuleStack, useDrawerState } from 'ui'
import { BuyTogetherEffect } from '../../../../../../typings'
import { ItemsView } from '../../../../../ItemsView'
import { DiscountRule } from '../../DiscountRule'
import styles from '../../styles'
import { BuyTogetherTriggerEditor } from '../Editor'
import { messages } from '../messages'
import { EmptyTrigger } from './Empty'
import { MinQuantityRule } from './MinQuantityRule'

type BuyTogetherTriggerViewProps = {
  config: BuyTogetherEffect
  onChange: (config: BuyTogetherEffect['trigger']) => void
  name: string
}

export function BuyTogetherTriggerView(props: BuyTogetherTriggerViewProps) {
  const { config, onChange, name } = props
  const { $t } = useIntl()

  const drawerState = useDrawerState()

  const handleRemove = () => onChange(undefined)

  const triggerConfig = config.trigger

  return (
    <div>
      {triggerConfig ? (
        <Flex direction="column" className={styles.view.content}>
          <Text variant="action1">{$t(messages.title, { index: 1 })}</Text>
          <FieldGroupBox name={name} withBorder={false}>
            <RuleStack>
              <ItemsView
                config={triggerConfig}
                onEdit={drawerState.show}
                onRemove={handleRemove}
              />
              <MinQuantityRule
                value={triggerConfig.minQuantity}
                onEdit={drawerState.show}
                onRemove={handleRemove}
              />
              <DiscountRule
                discount={triggerConfig.discount}
                onEdit={drawerState.show}
                onRemove={handleRemove}
              />
            </RuleStack>
          </FieldGroupBox>
        </Flex>
      ) : (
        <EmptyTrigger name={name} onAdd={drawerState.show} />
      )}

      <BuyTogetherTriggerEditor
        state={drawerState}
        initialConfig={config?.trigger}
        onSave={(newSettings) => onChange(newSettings)}
        benefit={config?.benefit}
      />
    </div>
  )
}
